import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import ConvertQuantity from '../../Shared/ConvertQuantity'
import measurementTypes from '../../../_constants/measurementTypes'


export default ({ touched, errors, setFieldValue, values, handleBlur, taskType }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>اطلاعات کلی سفارش</legend>

        <div className="row">
          <div className="form-inline">

            <div className="col-md-4 col-sm-12">
              <label>دسته بندی</label>
              <span className="text-label">
                {values.product && values.product.category.name}
              </span>
            </div>

            <div className="col-md-4 col-sm-12">
              <label>برند</label>
              <span className="text-label">
                {values.product && values.product.brand.name}
              </span>
            </div>

            <div className="col-md-4 col-sm-12">
              <label>نام کالا</label>
              <span className="text-label">
                {values.product && values.product.name}
              </span>
            </div>

            <div className="clearfix"></div>

            <div className="col-md-6 col-sm-12">
              <label>میزان سفارش {values && values.product && values.product.measurementType != undefined ? '(' + measurementTypes.filter(el => el.value === values.product.measurementType)[0].label + ')' : ''}</label>
              <span className="text-label">
                {values.quantity}
              </span>
              {/* <NumberFormat isNumericString allowNegative={false}
              disabled={!values.productId}
              defaultValue={values.quantity}
              value={values.quantity}
              name="quantity"
              onChange={(e) => {
                let q = e.target.value
                setFieldValue('quantity', q)

                if (q) {
                  let subQuantity = Math.round(q / values.product.conversionUnit)
                  setFieldValue('subQuantity', subQuantity)
                } else {
                  setFieldValue('subQuantity', undefined)
                }
              }}
              onBlur={handleBlur}
              className={getIn(touched, "quantity") ? getIn(errors, "quantity") ? "text-input has-error" : "text-input" : "text-input has-error"}
            /> */}
              <ErrorMessage component={ErrorPopUp} name="quantity" />
            </div>

            {/* {values.taskType && parseInt(values.taskType, 0) === 1 ? */}
            <div className="col-md-6 col-sm-12">
              <label>میزان سفارش {values && values.product && values.product.subMeasurementType != undefined ? '(' + measurementTypes.filter(el => el.value === values.product.subMeasurementType)[0].label + ')' : ''}</label>
              <span className="text-label">
                {values.product ? ConvertQuantity(values.quantity, values.product.conversionUnit, 3, 2) : ''}
              </span>
              {/* <NumberFormat isNumericString allowNegative={false}
                disabled={!values.productId}
                defaultValue={values.subQuantity}
                value={values.subQuantity}
                name="subQuantity"
                onChange={(e) => {
                  let q = e.target.value
                  setFieldValue('subQuantity', q)

                  if (q) {
                    // let quantity = Math.round(q * values.product.conversionUnit)
                    let quantity = Number((q * values.product.conversionUnit).toFixed(3))
                    setFieldValue('quantity', quantity)
                  } else {
                    setFieldValue('quantity', undefined)
                  }
                }}
                onBlur={handleBlur}
                className={getIn(touched, "subQuantity") ? getIn(errors, "subQuantity") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="subQuantity" /> */}
            </div>
            {/* : ''} */}
            <div className="clearfix"></div>

          </div>
        </div>

      </fieldset>

    </div>
    {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>اطلاعات کالا جهت تولید</legend>

        <table className="table validator-table" style={{ marginBottom: 5 }}>
          <thead>
            <tr>
              <th className="text-center">ردیف</th>
              <th className="text-center">دسته بندی</th>
              <th className="text-center">برند</th>
              <th className="text-center">نام کالا</th>
              <th className="text-center">کد کالا</th>
              <th className="text-center">واحد شمارش</th>
            </tr>
          </thead>
          <tbody>
            {values.outputs && values.outputs.map((item, index) => (
              <tr key={"p-" + index}>
                <td>{index + 1}</td>
                <td>
                  {values.outputs[index].product && values.outputs[index].product.category.name}
                </td>
                <td>
                  {values.outputs[index].product && values.outputs[index].product.brand.name}
                </td>
                <td>
                  {values.outputs[index].product && values.outputs[index].product.name}
                </td>
                <td>
                  {values.outputs[index].product && values.outputs[index].product.extraCode}
                </td>
                
                <td>
                  {values.product ? measurementTypes.filter(el => el.value === values.product.subMeasurementType)[0].label : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </fieldset>

    </div> */}

  </div>
);